import { InMemoryWebStorage, WebStorageStateStore } from 'oidc-client-ts';

// P2GApp's AuthenticationProvider (npm-p2g-app >= 2.8.1) keeps its OIDC user and state in
// `localStorage`, falling back to `sessionStorage` then memory. The callback pages build their own
// `UserManager`, and oidc-client-ts defaults its user store to `sessionStorage` - so the callback saved
// the user somewhere P2GApp never looks, and a redirect sign-in looped back to the identity server.
// This mirrors the package's `safeStorage()`, which it does not export.
export function oidcStorage(): Storage {
  return probe(() => window.localStorage) ?? probe(() => window.sessionStorage) ?? new InMemoryWebStorage();
}

// Accessing the property can throw (iOS Safari with cookies blocked), and private mode can expose the
// object but reject writes, so the probe both reads the property and round-trips a value.
function probe(get: () => Storage): Storage | null {
  const key = `__myaccount_storage_probe__${Date.now()}_${Math.random().toString(36).slice(2)}`;
  try {
    const storage = get();
    storage.setItem(key, key);
    storage.removeItem(key);
    return storage;
  } catch {
    return null;
  }
}

export function oidcStores() {
  const store = oidcStorage();
  return {
    userStore: new WebStorageStateStore({ store }),
    stateStore: new WebStorageStateStore({ store })
  };
}
